import i18n from 'i18next';
import { Application, CalculationType } from '../types/domainTypes';

export function getCalculationTypeText(type: CalculationType): string {
  switch (type) {
    case CalculationType.PanelCheck:
      return i18n.t('calculation.type-panel-check');
    case CalculationType.FastenerCheck:
      return i18n.t('calculation.type-fastener-check');
  }
}

export function getApplicationText(application: Application): string {
  return application === Application.RoofPanel
    ? i18n.t('calculation.application-roof-panel')
    : i18n.t('calculation.application-wall-panel');
}
